import { BaseLayout } from '~/src/components/shared/layout'
import { CategoryTitle } from '~/src/components/shared'
import { FestivalNavigation, FestivalBanner, FestivalPostGrid } from '~/src/components/festival'
import { FestivalPosition } from '~/src/generated/graphql'
import { FESTIVAL_CONTENTS_CATEGORY } from '~/src/const'
import { FestivalContextProvider } from '~/src/contexts'

export default function ContentsPage() {

  return (
    <BaseLayout>
      <FestivalContextProvider>
        <FestivalNavigation />
        <FestivalBanner position={FestivalPosition.Contents} />
        <CategoryTitle categoryId={FESTIVAL_CONTENTS_CATEGORY} />
        <FestivalPostGrid categoryId={FESTIVAL_CONTENTS_CATEGORY} />
      </FestivalContextProvider>
    </BaseLayout>
  )
}
